import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import { Form, Input, Select } from '@alifd/next';
import DataPreprocessDetailRoute from './route';
import { Radio, Tabs, Input as InputUdesk, PageHeader } from 'udesk-ui';
import AutoComplete from 'udesk-react/src/components/auto-complete';
import ConditionListGather from 'Component/pages/components/check-point-condition-list-gather';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import LanguageSelect from 'Component/pages/components/LanguageSelect';
import { LanguageEnum } from 'Component/pages/components/LanguageSelect/const';
import isNil from 'lodash/isNil';
import './style.scss';

const formItemLayout = {
    labelCol: {
        fixedSpan: 4,
    },
    wrapperCol: {
        span: 10,
    },
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    width: '32px',
    height: '24px',
    color: 'rgba(0,0,0,0.65)',
    borderRadius: '3px',
    margin: `0 ${grid}px 0 0 `,
    textAlign: 'center',
    lineHeight: '24px',
    // 拖拽的时候背景变化
    background: isDragging ? 'lightgreen' : 'rgba(232,244,255,1)',
    marginBottom: '3px',
    ...draggableStyle,
});

const getListStyle = () => ({
    background: '#fff',
    display: 'flex',
    padding: grid,
    overflow: 'auto',
});
const getListDropStyle = () => ({
    background: '#fff',
    display: 'flex',
    padding: grid,
    overflow: 'auto',
    width: '100%',
    border: '1px solid #e8e8e8',
    minHeight: '40px',
});

export default class DataPreprocessDetailTemplate extends DataPreprocessDetailRoute {
    render() {
        let {
            id,
            name,
            desc,
            dataSourceFlags,
            dataSource,
            statusFlags,
            status,
            entity,
            ruleType,
            customTypeList,
            ruleSecondaryType,
            conditionList,
            loading,
            lang,
        } = this.privates;

        let { actions, locales, privates } = this;

        const company = Udesk.data.init.company;

        return (
            <div className="udesk-qa-web-page">
                <PageHeader
                    className="udesk-qa-web-page-header"
                    onBack={actions.backToIndex}
                    title={
                        id
                            ? locales.components.pages.dataPreprocess.detail.edit
                            : locales.components.pages.dataPreprocess.detail.new
                    }
                />
                <div className="udesk-qa-web-page-body">
                    <div className="udesk-qa-web-page-body-root data-preprocess-detail-page-body">
                        <Form style={{ width: '100%' }} {...formItemLayout}>
                            <Form.Item
                                required
                                label={locales.components.pages.dataPreprocess.detail.name}
                            >
                                <Input
                                    name="name"
                                    disabled={
                                        ruleType === Udesk.enums.dataPreprocessTypes.system.id
                                    }
                                    value={name}
                                    maxCount={20}
                                    showCount={true}
                                    maxLength={20}
                                    onChange={actions.nameChanged}
                                />
                            </Form.Item>
                            <Form.Item label={locales.components.pages.dataPreprocess.detail.desc}>
                                <Input
                                    name="desc"
                                    disabled={
                                        ruleType === Udesk.enums.dataPreprocessTypes.system.id
                                    }
                                    value={desc}
                                    maxCount={100}
                                    showCount={true}
                                    maxLength={100}
                                    onChange={actions.descChanged}
                                />
                            </Form.Item>
                            <Form.Item
                                label={locales.components.pages.dataPreprocess.detail.dataSource}
                            >
                                <Select
                                    disabled={
                                        ruleType === Udesk.enums.dataPreprocessTypes.system.id ||
                                        !(
                                            company.enabledCallInspect !== 0 &&
                                            company.enabledImInspect !== 0
                                        )
                                    }
                                    name="dataSource"
                                    value={dataSource}
                                    dataSource={dataSourceFlags}
                                    onChange={actions.dataSourceChanged}
                                />
                            </Form.Item>

                            <Form.Item
                                label={
                                    /* 语言 */ UdeskLocales['current'].pages.intelligentAnalysis
                                        .dataPreprocess.detail.template.language
                                }
                            >
                                <LanguageSelect
                                    value={lang}
                                    hasAll
                                    onChange={actions.onLangChange}
                                    disabled={!!id}
                                />
                            </Form.Item>

                            <Form.Item
                                label={locales.components.pages.dataPreprocess.detail.status}
                            >
                                <Select
                                    name="status"
                                    value={status}
                                    dataSource={statusFlags}
                                    onChange={actions.statusChanged}
                                />
                            </Form.Item>
                            <If condition={ruleType === Udesk.enums.dataPreprocessTypes.custom.id}>
                                <Form.Item label={locales.fix.type}>
                                    <Select
                                        name="customType"
                                        value={ruleSecondaryType}
                                        dataSource={customTypeList}
                                        onChange={actions.customTypeChanged}
                                    />
                                </Form.Item>
                                <If
                                    condition={
                                        ruleSecondaryType ===
                                        Udesk.enums.dataSourceCutom.smartTag.id
                                    }
                                >
                                    <Form.Item
                                        required
                                        label={
                                            locales.components.pages.dataPreprocess.detail.entity
                                        }
                                    >
                                        <AutoComplete
                                            name="entity"
                                            enableEmptySearch={true}
                                            value={entity}
                                            onChanged={actions.entityChanged}
                                            url="/backend/information-entity/list"
                                            extraQueryParams={{
                                                activeFlag: 1,
                                                langList: !isNil(lang)
                                                    ? lang === LanguageEnum.All
                                                        ? [lang]
                                                        : [LanguageEnum.All, lang]
                                                    : undefined,
                                            }}
                                            method="POST"
                                            queryParamName="keyword"
                                            valueField="id"
                                            key={lang}
                                        />
                                    </Form.Item>
                                </If>
                                <Form.Item
                                    label={locales.components.pages.dataPreprocess.detail.operator}
                                >
                                    <ConditionListGather
                                        conditionList={conditionList}
                                        type={[dataSource]}
                                        ruglar="preprocess"
                                        onChange={actions.getConditionList}
                                        lang={lang}
                                        isAutoAssociateDateSource={dataSource !== 0} // 数据源是无限制的情况下才会显示内部数据源选择
                                    ></ConditionListGather>
                                </Form.Item>
                                <Form.Item
                                    label={locales.components.pages.dataPreprocess.detail.rule}
                                >
                                    <div className="tasks-manage-template-configuration-detail-logic-rule">
                                        <Radio.Group
                                            onChange={actions.onGradeTypeChange}
                                            value={privates.compositeType}
                                        >
                                            <Radio value={1}>
                                                {
                                                    UdeskLocales.current.pages.tasks.manage.template
                                                        .checkPoint.configuration.logic.all
                                                }
                                            </Radio>
                                            <Radio value={2}>
                                                {
                                                    UdeskLocales.current.pages.tasks.manage.template
                                                        .checkPoint.configuration.logic.any
                                                }
                                            </Radio>
                                            <Radio value={3}>
                                                {
                                                    UdeskLocales.current.pages.tasks.manage.template
                                                        .checkPoint.configuration.logic.customize
                                                }
                                            </Radio>
                                        </Radio.Group>
                                        <If condition={privates.compositeType === 3}>
                                            <Tabs defaultActiveKey="2">
                                                <Tabs.TabPane
                                                    tab={
                                                        UdeskLocales.current.components.common
                                                            .customFilter.manualConfiguration
                                                    }
                                                    key="1"
                                                >
                                                    <InputUdesk
                                                        placeholder={
                                                            UdeskLocales.current.components.common
                                                                .customFilter.holderCustomRule
                                                        }
                                                        value={privates.operatorLogic}
                                                        onChange={actions.customJudgeLogicChange}
                                                    />
                                                    {/* <input type="text" className="form-control" defaultValue={operatorLogic} onChange={actions.mutator("privates.operatorLogic", e => e.target.value)} /> */}
                                                </Tabs.TabPane>
                                                <Tabs.TabPane
                                                    tab={
                                                        UdeskLocales.current.components.common
                                                            .customFilter.dragConfiguration
                                                    }
                                                    key="2"
                                                >
                                                    <DragDropContext
                                                        onDragEnd={actions.onDragEnd}
                                                        onDragStart={actions.onDragStart}
                                                    >
                                                        <div className="data-preprocess-custom">
                                                            <div className="data-preprocess-custom-drap-title">
                                                                {
                                                                    UdeskLocales.current.components
                                                                        .common.customFilter
                                                                        .condition
                                                                }
                                                                ：
                                                            </div>
                                                            <div className="data-preprocess-cutom-drap-info">
                                                                <Droppable
                                                                    droppableId="droppables"
                                                                    direction="horizontal"
                                                                    isDropDisabled={true}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <div
                                                                            {...provided.droppableProps}
                                                                            ref={provided.innerRef}
                                                                            style={getListStyle(
                                                                                snapshot.isDraggingOver
                                                                            )}
                                                                        >
                                                                            {privates.conditionListFilter.map(
                                                                                (item, index) => (
                                                                                    <Draggable
                                                                                        key={
                                                                                            item.id
                                                                                        }
                                                                                        draggableId={
                                                                                            item.id
                                                                                        }
                                                                                        index={
                                                                                            index
                                                                                        }
                                                                                    >
                                                                                        {(
                                                                                            provided,
                                                                                            snapshot
                                                                                        ) => (
                                                                                            <div
                                                                                                ref={
                                                                                                    provided.innerRef
                                                                                                }
                                                                                                {...provided.draggableProps}
                                                                                                {...provided.dragHandleProps}
                                                                                                style={getItemStyle(
                                                                                                    snapshot.isDragging,
                                                                                                    provided
                                                                                                        .draggableProps
                                                                                                        .style
                                                                                                )}
                                                                                            >
                                                                                                {
                                                                                                    item.content
                                                                                                }
                                                                                            </div>
                                                                                        )}
                                                                                    </Draggable>
                                                                                )
                                                                            )}
                                                                            {provided.placeholder}
                                                                        </div>
                                                                    )}
                                                                </Droppable>
                                                            </div>
                                                        </div>
                                                        <div className="data-preprocess-custom">
                                                            <div className="data-preprocess-custom-drap-title">
                                                                {
                                                                    UdeskLocales.current.components
                                                                        .common.customFilter
                                                                        .condition
                                                                }
                                                                ：
                                                            </div>
                                                            <div className="data-preprocess-cutom-drap-info">
                                                                <Droppable
                                                                    droppableId="droppabless"
                                                                    direction="horizontal"
                                                                    isDropDisabled={true}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <div
                                                                            {...provided.droppableProps}
                                                                            ref={provided.innerRef}
                                                                            style={getListStyle(
                                                                                snapshot.isDragging
                                                                            )}
                                                                        >
                                                                            {privates.logicList
                                                                                .filter(
                                                                                    (item) =>
                                                                                        item.flag
                                                                                )
                                                                                .map(
                                                                                    (
                                                                                        item,
                                                                                        index
                                                                                    ) => (
                                                                                        <Draggable
                                                                                            key={
                                                                                                item.id
                                                                                            }
                                                                                            draggableId={
                                                                                                item.id
                                                                                            }
                                                                                            index={
                                                                                                index
                                                                                            }
                                                                                        >
                                                                                            {(
                                                                                                provided,
                                                                                                snapshot
                                                                                            ) => (
                                                                                                <div
                                                                                                    ref={
                                                                                                        provided.innerRef
                                                                                                    }
                                                                                                    {...provided.draggableProps}
                                                                                                    {...provided.dragHandleProps}
                                                                                                    style={getItemStyle(
                                                                                                        snapshot.isDragging,
                                                                                                        provided
                                                                                                            .draggableProps
                                                                                                            .style
                                                                                                    )}
                                                                                                >
                                                                                                    {
                                                                                                        item.content
                                                                                                    }
                                                                                                </div>
                                                                                            )}
                                                                                        </Draggable>
                                                                                    )
                                                                                )}
                                                                            {provided.placeholder}
                                                                        </div>
                                                                    )}
                                                                </Droppable>
                                                            </div>
                                                        </div>
                                                        <div className="data-preprocess-custom">
                                                            {privates.tarskDel && (
                                                                <div className="index-manmagement-custom-drag-tarsk">
                                                                    {
                                                                        UdeskLocales.current
                                                                            .components.common
                                                                            .customFilter.infoDel
                                                                    }
                                                                </div>
                                                            )}
                                                            <div className="data-preprocess-custom-drap-title">
                                                                {
                                                                    UdeskLocales.current.components
                                                                        .common.customFilter
                                                                        .toConfigure
                                                                }
                                                                ：
                                                            </div>
                                                            <div className="data-preprocess-cutom-drap-info">
                                                                <Droppable
                                                                    droppableId="droppable"
                                                                    direction="horizontal"
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <div
                                                                            {...provided.droppableProps}
                                                                            ref={provided.innerRef}
                                                                            style={getListDropStyle(
                                                                                snapshot.isDraggingOver
                                                                            )}
                                                                        >
                                                                            {this.privates.items.map(
                                                                                (item, index) => (
                                                                                    <Draggable
                                                                                        key={
                                                                                            item.id
                                                                                        }
                                                                                        draggableId={
                                                                                            item.id
                                                                                        }
                                                                                        index={
                                                                                            index
                                                                                        }
                                                                                    >
                                                                                        {(
                                                                                            provided,
                                                                                            snapshot
                                                                                        ) => (
                                                                                            <div
                                                                                                ref={
                                                                                                    provided.innerRef
                                                                                                }
                                                                                                {...provided.draggableProps}
                                                                                                {...provided.dragHandleProps}
                                                                                                style={getItemStyle(
                                                                                                    snapshot.isDragging,
                                                                                                    provided
                                                                                                        .draggableProps
                                                                                                        .style
                                                                                                )}
                                                                                            >
                                                                                                {
                                                                                                    item.content
                                                                                                }
                                                                                            </div>
                                                                                        )}
                                                                                    </Draggable>
                                                                                )
                                                                            )}
                                                                            {provided.placeholder}
                                                                        </div>
                                                                    )}
                                                                </Droppable>
                                                            </div>
                                                        </div>
                                                    </DragDropContext>
                                                </Tabs.TabPane>
                                            </Tabs>
                                        </If>
                                    </div>
                                </Form.Item>
                            </If>
                            <Form.Item label=" ">
                                <Form.Reset type="normal" onClick={actions.backToIndex}>
                                    {locales.labels.cancel}
                                </Form.Reset>
                                &nbsp;
                                <Form.Submit
                                    type="primary"
                                    onClick={actions.saveDataPreprocess}
                                    loading={loading}
                                >
                                    {locales.labels.save}
                                </Form.Submit>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}
